import { Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import packageJson from '../../../../package.json';

@Injectable({
  providedIn: 'root'
})
export class AppMetaService {
  readonly version = signal(packageJson.version);
  readonly versionDate = signal(packageJson.versionDate);
  readonly environment = signal(environment.production ? '' : environment.environment);
}

